<template>
  <div class="padding-top-5">
    <div
      v-if="conditions.length > 1"
    >
      <PaymentTermDisplay
        v-for="term in conditions"
        :key="term.id"
        :term="term"
      />
    </div>
    <div
      v-else-if="conditions.length === 1 && order.fifty_k_payment_term"
    >
      <PaymentTermDisplay
        v-for="term in fifty_k_payment_terms"
        :key="term.id"
        :term="term"
      />
    </div>
    <div
      v-else
      class="font-size-12"
    >
      {{ order.total_decorated }}
    </div>
  </div>
</template>

<script>

import PaymentTermDisplay from '../../cart/payment_terms/term_display'
export default {

  components: {
    PaymentTermDisplay
  },

  props: {
    index: {
      default: 0,
      type: Number
    }
  },
  computed: {
    order(){
      return this.$store.state.order.order
    },
    conditions(){
      return this.order.payment_term_options[this.index]
    },
    fifty_k_payment_terms(){
      return this.order.payment_terms
    },
  },
}
</script>
